import React from 'react';
import type Transit from '@this/src/domain/transit/transit';
import type { ShortDistanceMode } from '@this/lib/hooks/useShortDistance';
import type SelectStore from '../../../../../domain/select_store';
import { Box } from '../../shared/box_parts';
import IndividualDetail from '../short_distance/individual/IndividualDetail';
import PackageDetail from '../short_distance/package/PackageDetail';

interface TransportBoxShortDistanceContainerProps {
  transit: Transit;
  selected: boolean;
  selectedLegSummaryIndex: number | null;
  domesticAirPriceIndex: number;
  store: SelectStore;
  isRequestForm?: boolean;
  handleChange: (legSummaryIndex?: number) => void;
  shortDistanceMode: ShortDistanceMode;
  candidateCount: number;
}

const TransportBoxShortDistanceContainer: React.FC<TransportBoxShortDistanceContainerProps> = ({
  transit,
  selected,
  selectedLegSummaryIndex,
  domesticAirPriceIndex,
  handleChange,
  store,
  isRequestForm,
  shortDistanceMode,
  candidateCount
}) => {
  return (
    <Box selected={false}>
      {transit.segments.map((segment, i) => {
        return transit.package ? (
          <PackageDetail
            key={i.toString()}
            transport={transit}
            selected={selected}
            handleChange={handleChange}
            store={store}
            isRequestForm={isRequestForm}
            segment={segment}
            segmentIdx={i}
            candidateCount={candidateCount}
          />
        ) : (
          <IndividualDetail
            key={i.toString()}
            transit={transit}
            selected={selected}
            selectedLegSummaryIndex={selectedLegSummaryIndex}
            domesticAirPriceIndex={domesticAirPriceIndex}
            handleChange={handleChange}
            store={store}
            isRequestForm={isRequestForm}
            segment={segment}
            segmentIdx={i}
            shortDistanceMode={shortDistanceMode}
            candidateCount={candidateCount}
          />
        );
      })}
    </Box>
  );
};

export default TransportBoxShortDistanceContainer;
